import { inject, Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private readonly keycloak = inject(Keycloak);

    get displayName(): string {
        const token = this.keycloak.tokenParsed;
        const fullName = [token?.['given_name'], token?.['family_name']].filter(Boolean).join(' ');
        return token?.['name'] || fullName || token?.['preferred_username'] || 'Benutzer';
    }

    get email(): string {
        return this.keycloak.tokenParsed?.['email'] || '';
    }

    get username(): string {
        return this.keycloak.tokenParsed?.['preferred_username'] || '';
    }

    get groups(): string[] {
        const groups = this.keycloak.tokenParsed?.['groups'];
        return Array.isArray(groups) ? groups.map((group: string) => group.replace(/^\//, '')) : [];
    }

    get initials(): string {
        const parts = this.displayName.split(/[\s.@_-]+/).filter(Boolean);
        const initials = parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : (parts[0] || '?').slice(0, 2);
        return initials.toUpperCase();
    }

    logout() {
        this.keycloak.logout({
            redirectUri: window.location.origin + '/'
        });
    }
}
